import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Form, registerField } from 'core/forms';

const FormFieldObject = ({ fieldId, schema, updateField, value = {} }) => {
  const handleUpdate = ({ update }) => {
    const newValue = { ...(value || {}), ...update };

    updateField(newValue);
  };

  return (
    <div>
      <Form
        onUpdate={handleUpdate}
        schema={schema.subSchema}
        model={value || {}}
        fieldId={fieldId}
      />
    </div>
  );
};

FormFieldObject.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    subSchema: PropTypes.shape({}).isRequired,
  }).isRequired,
  updateField: PropTypes.func.isRequired,
  value: PropTypes.shape({}),
};

registerField('Object', memo(FormFieldObject));

export default FormFieldObject;
